import axios from "axios";
import * as localforage from "localforage";
import { goUrl } from "./apiSetup";
import { t } from "../langs/useTranslation";
import { errorHandling } from "../helpers/errorHandling";
import { toast } from "@/helpers/toast";

export function getErrorMsg(code) {
  const ERROR_CODE_MSG = {
    0: t({ defaultMessage: "未知错误" }),
    30000: t({ defaultMessage: "参数错误" }),
    40000: t({ defaultMessage: "用户没有绑定邮箱，无法进行验证" }),
    40001: t({ defaultMessage: "请勿频繁发送验证码！" }),
    40002: t({ defaultMessage: "验证失败" })
  };
  return ERROR_CODE_MSG[code];
}

export const request = axios.create({
  // baseURL: goUrl + "/fec/platform/v3"
});

const origHttpGet = request.get;

// 重写get方法，保持跟post方法传参一致
request.get = (url, params, config) => {
  return origHttpGet(url, { params, ...config });
};

request.interceptors.request.use(
  async config => {
    const token = await localforage.getItem("token");
    const lang = localStorage.getItem("rcml-lang");
    config.baseURL = goUrl + "/fec/platform/v3";
    config.headers.Authorization = `Bearer ${token}`; // token || "";
    config.headers.Accept = "application/json";
    config.headers.AcceptLanguage = lang || "en";
    //config.withCredentials = true;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  response => {
    const { data } = response;
    if (data.code) {
      const err = new Error(
        getErrorMsg(data.code) || data.message || "unknown error"
      );
      err.code = data.code;
      toast.error(err.message);
      return Promise.reject(err);
    }
    return data;
  },
  err => {
    if (err.name !== "CanceledError") {
      console.error(err);
    }
    errorHandling(err);
    return Promise.reject(err);
  }
);
